import type { NextPage, GetServerSideProps } from 'next'
import SEO from '@/modules/seo'

export const getServerSideProps: GetServerSideProps = async (context) => {
  return {
    redirect: {
      permanent: true,
      destination: "/opinion/decision",
    },
    props: {
    }
  }
}

interface IProps {

}

const Component: NextPage<IProps> = (props) => {
  const pageTitle = "도민참여"
  const pageDescription = ""

  return (
    <>
      <SEO title={pageTitle} description={pageDescription} />
    </>
  )
}

export default Component
